import { useMemo } from "react";
import useEditorStore from "../stores/useEditorStore";
import { toolRegistry } from "../components/tools/toolRegistry";

export function useToolManager() {
    const activeTool = useEditorStore((state) => state.activeTool);
    const execCommand = useEditorStore((state) => state.execCommand);

    const entry = useMemo(() => toolRegistry[activeTool], [activeTool]);

    return{
        activeTool,
        run: (params, toolId = null) => {
            // Use specific toolId if provided, otherwise use current activeTool entry
            const targetEntry = toolId ? toolRegistry[toolId] : entry;
            const targetToolId = toolId || activeTool;

            if(!targetEntry) {
                console.warn(`No tool registered for: ${targetToolId}`);
                return;
            }

            const command = targetEntry.exec(params);
            if(command)
                execCommand(command);
        }
    }
};